import React, { ReactElement } from 'react'
import styled from 'styled-components'
import {
  AsyncButton,
  ButtonStyle,
  InputField,
  InputType,
} from '@one-tree/library'
import CardContent from '../../components/page/CardContent'
import CardHeader from '../../components/page/CardHeader'
import { useOrganisation } from '../../context/OrganisationProvider'
import { capitalize } from '../../helpers/DataTransformer'
import { voucherWord } from '../../helpers/FormatHelper'
import useResponsive from '../../helpers/isResponsive'
import { StateAction } from '../../types/Aliases'
import { OrganisationFormat } from '../../types/Types'
import CodeInput from '../../components/fields/codeField/CodeInput'

const UserForm = styled.form`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-row-gap: 20px;
  grid-column-gap: 30px;
  .double-section {
    grid-area: 3 / 1 / 4 / 3;
    display: inline-flex;
    align-items: flex-end;
    justify-content: space-between;
    ${(props): string => props.theme.isMobile
      && 'flex-direction: column; row-gap: 10px; align-items: flex-start;'}
  }
  ${(props): string => props.theme.isMobile && 'grid-row-gap: 0;'}
`

interface UserSearchProps {
  searchGiftCard: () => void
  purchaserName: string
  setPurchaserName: (value: string) => void
  recipientName: string
  setRecipientName: (value: string) => void
  orderId: string
  setOrderId: (value: string) => void
  voucherId: string
  setVoucherId: StateAction<string>
  voucherCode: string
  setVoucherCode: StateAction<string>
}

function UserSearch(props: UserSearchProps): ReactElement {
  const {
    searchGiftCard,
    purchaserName,
    setPurchaserName,
    recipientName,
    setRecipientName,
    orderId,
    setOrderId,
    voucherId,
    setVoucherId,
    voucherCode,
    setVoucherCode,
  } = props
  const { organisation } = useOrganisation()

  return (
    <>
      <CardHeader title={`Find a ${voucherWord(organisation)}`} />
      <CardContent>
        <p>
          Search on any ONE of the following to check, amend or redeem a{' '}
          {voucherWord(organisation)}.
        </p>
        <UserForm
          onSubmit={(event): void => event.preventDefault()}
          theme={useResponsive()}
        >
          <InputField
            type={InputType.Text}
            label="Purchaser's name"
            value={purchaserName}
            onChange={setPurchaserName}
          />
          {organisation?.format === OrganisationFormat.GiftVouchers ? (
            <InputField
              type={InputType.Text}
              label="Recipient's name"
              value={recipientName}
              onChange={setRecipientName}
            />
          ) : (
            <br />
          )}
          <InputField
            type={InputType.Text}
            label="Order ID"
            value={orderId}
            onChange={setOrderId}
          />
          <InputField
            type={InputType.Text}
            label={`${capitalize(voucherWord(organisation))} ID`}
            value={voucherId}
            onChange={setVoucherId}
          />
          <div className="double-section">
            <CodeInput
              value={voucherCode}
              onChange={setVoucherCode}
              label="16 character code"
            />
            <AsyncButton
              buttonStyle={ButtonStyle.Primary}
              onClick={searchGiftCard}
              style={{ minWidth: '65px' }}
            >
              Search
            </AsyncButton>
          </div>
        </UserForm>
      </CardContent>
    </>
  )
}
export default UserSearch
